import React, { useState } from 'react';
import { FaClock } from 'react-icons/fa';
import styled, { css } from 'styled-components';
import { CommonText } from '../../bumpViews/commonText';
import { IconCircle } from '../../elements/icon.circle/index2';
import { OrderIcon } from '../../order/order-icon';
import { useTranslation } from 'react-i18next';
import { DetailOrderCard } from '../detail-order';
import { Checkedbox, EmptyCheckbox, ListItem } from '../components';
import { ChangeOrderStatusSidebar } from '../sidebars/changeOrderStatus';
import { Sidebar } from '../../sidebar';
import { EllipsisButton } from '../../bumpViews/ellipsis';
import { EstimatedTime } from '../sidebars/estimateTime';
import { BottomButton } from './bottomButton';
import { PaymentCardMobileIcon } from '../../logo/credit-card-logo';
const ListItemIcon = styled.div `
  display: flex;
  align-items: center;
  font-size: 20px;
`;
const ListItemWraper = styled.div `
  font-size: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const ListItemContent = styled('div') `
  display: flex;
  align-items: center;
  cursor: pointer;
`;
const SmallCardTextWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  .payment-section,
  .due-section {
    display: flex;
    align-items: center;
    svg {
      margin-right: 8px;
    }
  }
`;
const BottomBtnWrapper = styled.div `
  margin-top: 24px;
  gap: 12px;
  button {
    padding: 0;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
const ActionButtonWrapper = styled.div `
  position: fixed;
  bottom: 0;
  width: 100%;
  left: 0;
  display: flex;
  padding: 8px 16px;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border-top: 1px solid #dfdfdf;
  background: #fff;
  z-index: 12;
`;
const ChangeStatusButton = styled.div `
  display: flex;
  flex: 1;
  background-color: #fb2f2f;
  color: #fff;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 12px;
`;
const CancelButton = styled.div `
  background-color: #f1f4f7;
  color: #4b4f5e;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
`;
const MoreActionButtonWrapper = styled.div `
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const MoreActionButton = styled.div `
  display: flex;
  width: 100%;
  padding: 12px 16px;
  align-items: center;
  height: 64px;
  justify-content: center;
  border-radius: 4px;
  ${({ isDeleteButton }) => isDeleteButton
    ? css `
          background-color: #bc362f;
          color: #fefefe;
        `
    : css `
          background-color: #f5f5f5;
          color: #4b4f5e;
        `}
`;
const mapServiceKeyToName = (key) => {
    switch (key) {
        case 'pickup':
            return 'Pickup';
        case 'delivery':
            return 'Delivery';
        case 'dine_in':
            return 'Dine in';
        case 'booking':
            return 'Table Bookings';
    }
};
export const SingleBoardCard = (props) => {
    const { showCheckbox, selectedOrders, setSelectedOrders, order, handleChangeStatus, onDeleteOrder, hidePrices, items, region, timezones, status, mapData, printerNames, handleSelectPrinter, theme, paymentName, handleSelectOption, totalOrderStatus, openEstimateTime, setOpenEstimateTime } = props;
    const { t } = useTranslation();
    const [detailsModal, setDetailsModal] = useState(false);
    const [changeOrderStatus, setChangeOrderStatus] = useState(false);
    const [openMoreAction, setOpenMoreAction] = useState(false);
    const [openPrintOrder, setOpenPrintOrder] = useState(false);
    const isChecked = selectedOrders.includes(order._id);
    const uom = region.kmmile === 'KM' ? "Km's" : 'miles';
    const conversionNumber = region.kmmile === 'KM' ? 1000 : 1609;
    const handleOpen = () => {
        setDetailsModal(true);
    };
    const handleClose = () => {
        setDetailsModal(false);
    };
    const handleChangeOrderStatus = () => {
        setChangeOrderStatus(true);
    };
    const handleChangeStatusOrder = async (status) => {
        await handleChangeStatus(order, status);
        setDetailsModal(false);
    };
    const handleOpenMoreAction = () => {
        setOpenMoreAction(true);
    };
    const handleCancelOrder = async () => {
        if (order.status !== 'cancelled') {
            await handleChangeStatus(order, 'cancelled');
        }
        setDetailsModal(false);
    };
    const handleDeleteOrder = async () => {
        await onDeleteOrder(false, order);
        setDetailsModal(false);
    };
    const printerOptions = printerNames ? printerNames.filter(printer => !printer.disabled) : [];
    const handlePrintOrder = () => {
        if (printerOptions.length !== 1) {
            setOpenPrintOrder(true);
            setDetailsModal(false);
        }
        else {
            handleSelectPrinter(order, printerNames[0]._id);
            setDetailsModal(false);
        }
    };
    const handleEstimateTime = () => {
        setOpenEstimateTime(true);
    };
    const handleItemClick = () => {
        if (showCheckbox && order._id) {
            const isExistedId = selectedOrders.find(orderId => orderId === order._id);
            if (!isExistedId) {
                setSelectedOrders([...selectedOrders, order._id]);
            }
            else {
                const filteredExistedItem = selectedOrders.filter(orderId => orderId !== order._id);
                setSelectedOrders(filteredExistedItem);
            }
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ListItem, { onClick: handleItemClick, active: showCheckbox && isChecked },
            React.createElement(ListItemWraper, null,
                React.createElement(ListItemIcon, null,
                    React.createElement(IconCircle, { size: 28, iconSizeModifier: 12, icon: React.createElement(OrderIcon, { service: order.config.service }), background: '#DFDFDF', color: '#4B4F5E' }),
                    React.createElement(CommonText, { size: "semiMedium", weight: 500, color: "#6B7270", style: {
                            marginLeft: '8px',
                        } }, mapServiceKeyToName(order.config.service))),
                showCheckbox && !isChecked && React.createElement(EmptyCheckbox, null),
                showCheckbox && isChecked && React.createElement(Checkedbox, null)),
            React.createElement(ListItemContent, null,
                React.createElement("div", { style: {
                        width: '100%',
                    } },
                    React.createElement("div", { className: "flex-l-r flex-grow" },
                        React.createElement("div", { className: "child-mb-7" },
                            React.createElement(CommonText, { size: "medium", weight: 600, color: "#0C202A" },
                                order.number,
                                " - ",
                                order.customer.name)),
                        React.createElement("div", { className: "child-mb-7 text-right", style: { minWidth: '80px' } },
                            React.createElement(CommonText, { size: "medium", weight: 600, color: "#0C202A" }, t('currency', { value: order.bill.total })))),
                    React.createElement(SmallCardTextWrapper, null,
                        React.createElement("div", { className: "payment-section" },
                            React.createElement(PaymentCardMobileIcon, null),
                            React.createElement(CommonText, { size: "small", weight: 500, color: "#6B7270" }, paymentName)),
                        React.createElement("div", { className: "due-section" },
                            React.createElement(FaClock, { color: "#6B7270" }),
                            React.createElement(CommonText, { size: "small", weight: 500, color: "#6B7270" }, "Due in 2 hours"))))),
            React.createElement(BottomButton, { o: order, updateStatus: handleChangeStatus, sc: theme, handleOpenDetail: handleOpen })),
        React.createElement(DetailOrderCard, { isOpen: detailsModal, close: handleClose, order: order, hidePrices: hidePrices, items: items, rates: region.tax.rates, timezones: timezones, status: status, theme: theme, uom: uom, conversionNumber: conversionNumber, mapData: mapData }),
        detailsModal && (React.createElement(React.Fragment, null,
            !openMoreAction && React.createElement(ActionButtonWrapper, null,
                React.createElement(ChangeStatusButton, { onClick: handleChangeOrderStatus }, "Change Status"),
                React.createElement(CancelButton, { onClick: handleCancelOrder }, "Cancel Order"),
                React.createElement("div", { style: { flex: '0 0 40px' }, onClick: handleOpenMoreAction },
                    React.createElement(EllipsisButton, null))),
            React.createElement(ChangeOrderStatusSidebar, { isOpen: changeOrderStatus, handleClose: () => setChangeOrderStatus(false), onChangeStatusOrder: handleChangeStatusOrder, isMobile: true, selectedOrders: 1, totalOrderStatus: totalOrderStatus }),
            React.createElement(Sidebar, { isOpen: openMoreAction, headerTitle: "More Action", onClose: () => setOpenMoreAction(false), isMobile: true },
                React.createElement(MoreActionButtonWrapper, null,
                    React.createElement(MoreActionButton, { onClick: handlePrintOrder }, "Print"),
                    React.createElement(MoreActionButton, { onClick: handleEstimateTime }, "Other Options"),
                    React.createElement(MoreActionButton, { isDeleteButton: true, onClick: handleDeleteOrder }, "Delete Order"))))),
        React.createElement(EstimatedTime, { order: order, isOpen: openEstimateTime, handleClose: () => {
                setOpenEstimateTime(false);
            }, handleSelectOption: handleSelectOption, isMobile: true })));
};
//# sourceMappingURL=index.js.map